import { render, staticRenderFns } from "./company-detail.vue?vue&type=template&id=78902d46&scoped=true"
import script from "./company-detail.vue?vue&type=script&lang=js"
export * from "./company-detail.vue?vue&type=script&lang=js"
import style0 from "./company-detail.vue?vue&type=style&index=0&id=78902d46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78902d46",
  null
  
)

export default component.exports